import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

/* eslint-disable no-new */
const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    OrgObject: {},
    phoneNumber: "",
    productsDetails: {}
  },
  getters: {
    GetUserDetails: state => {
      return state.OrgObject;
    },
    GetphoneNumber: state => {
      return state.phoneNumber;
    },
    GetProductsDetails: state => {
      return state.productsDetails;
    },
  },
  mutations: {
    SetUserDetails(state, OrgObject) {
      state.OrgObject = OrgObject;
    },
    SetphoneNumber(state, phoneNumber) {
      state.phoneNumber = phoneNumber;
    },
    SetProductsDetails(state, productsDetails) {
      state.productsDetails = productsDetails;
    },
  },
  modules: {
  }
})

export default store
